import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Router from './routes/router';
import './App.css';

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
